import React, { useRef, useEffect, useState } from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { propTypes } from '../../util/types';

import {
  Button,
  LayoutComposer,
  LayoutSingleColumn,
  NamedRedirect,
  Page,
  VideoPlayer,
} from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import StaticPage from '../PageBuilder/StaticPage';
import FooterContainer from '../FooterContainer/FooterContainer.js';
import { validProps } from '../PageBuilder/Field';
import { ReactComponent as Joinfree } from './icons/join_icon.svg';
import { ReactComponent as CreateList } from './icons/create-list_icon.svg';
import { ReactComponent as DeliverEx } from './icons/del-ex_icon.svg';
import { ReactComponent as GetPaid } from './icons/get-paid_icon.svg';
import { ReactComponent as PrevButton } from '../LandingPage/icons/prevArrow.svg';
import { ReactComponent as NextButton } from '../LandingPage/icons/nextArrow.svg';
import PetStarAcademyGraphic from '../../assets/PetStarAcademyGraphic.png';
import Benefitsofselling from '../../assets/Benefitsofselling.png';
import HeroVideo from '../../assets/SellerPageHeaderVideo.mp4';
import rider from '../LandingPage/icons/rider.png';

import b7 from '../LandingPage/icons/brands/7.png';
import b8 from '../LandingPage/icons/brands/8.png';
import b9 from '../LandingPage/icons/brands/9.png';
import b10 from '../LandingPage/icons/brands/10.png';
import b11 from '../LandingPage/icons/brands/11.png';
import b12 from '../LandingPage/icons/brands/12.png';
import b13 from '../LandingPage/icons/brands/13.png';
import b14 from '../LandingPage/icons/brands/14.png';
import b15 from '../LandingPage/icons/brands/15.png';
import b16 from '../LandingPage/icons/brands/16.png';
import b17 from '../LandingPage/icons/brands/17.png';
import b18 from '../LandingPage/icons/brands/18.png';
import b19 from '../LandingPage/icons/brands/19.png';
import b20 from '../LandingPage/icons/brands/20.png';
import b21 from '../LandingPage/icons/brands/21.png';
import b22 from '../LandingPage/icons/brands/22.png';
import b23 from '../LandingPage/icons/brands/23.png';
import b24 from '../LandingPage/icons/brands/24.png';
import b25 from '../LandingPage/icons/brands/25.png';
import b26 from '../LandingPage/icons/brands/26.png';
import b27 from '../LandingPage/icons/brands/27.png';
import b28 from '../LandingPage/icons/brands/28.png';
import b29 from '../LandingPage/icons/brands/29.png';
import b30 from '../LandingPage/icons/brands/30.png';
import b32 from '../LandingPage/icons/brands/32.png';
import b34 from '../LandingPage/icons/brands/34.png';
import b35 from '../LandingPage/icons/brands/35.png';
import b36 from '../LandingPage/icons/brands/36.png';
import b37 from '../LandingPage/icons/brands/37.png';

import wtmm1 from '../../assets/WaysToMakeMoney1.png';
import wtmm2 from '../../assets/WaysToMakeMoney2.png';
import wtmm3 from '../../assets/WaysToMakeMoney3.png';
import wtmm4 from '../../assets/WaysToMakeMoney4.png';
import wtmm5 from '../../assets/WaysToMakeMoney5.png';
import wtmm6 from '../../assets/WaysToMakeMoney6.png';
import wtmm7 from '../../assets/WaysToMakeMoney7.png';
import wtmm8 from '../../assets/WaysToMakeMoney8.png';
import wtmm9 from '../../assets/WaysToMakeMoney9.png';
import wtmm10 from '../../assets/WaysToMakeMoney10.png';

import css from './SellerLandingPage.module.css';

import Slider from 'react-slick';
import { withViewport } from '../../util/uiHelpers.js';
import '../LandingPage/slick.css';
import { createResourceLocatorString } from '../../util/routes.js';
import { useRouteConfiguration } from '../../context/routeConfigurationContext.js';
import { withRouter } from 'react-router-dom';

const wayToMoney = [
  { icon: wtmm1, label: 'Pet Influencers' },
  { icon: wtmm2, label: 'Pet Content Creators' },
  { icon: wtmm3, label: 'Animal Actors' },
  { icon: wtmm4, label: 'Therapy Animals' },
  { icon: wtmm5, label: 'Certified Wrangler' },
  { icon: wtmm6, label: 'Event Animals' },
  { icon: wtmm7, label: 'Pet Photographers' },
  { icon: wtmm8, label: 'Working Animals' },
  { icon: wtmm9, label: 'Animal Professionals' },
  { icon: wtmm10, label: 'Educational Animals' },
];

const howALWorks = [
  {
    icon: <Joinfree />,
    heading: 'Join For Free',
    desc: ' Showcase your Petfolio and animal talent to a world of opportunities.',
  },
  {
    icon: <CreateList />,
    heading: 'Create A Listing',
    desc: 'Once on board, spotlight your unique skills with compelling listings.',
  },
  {
    icon: <DeliverEx />,
    heading: 'Deliver Excellence',
    desc: 'Receive job notifications and connect with customers effortlessly.',
  },
  {
    icon: <GetPaid />,
    heading: 'Get Paid',
    desc: 'Receive payment promptly after successfully completing your job.',
  },
];

const brandImgs = [
  b7,
  b8,
  b9,
  b10,
  b11,
  b12,
  b13,
  b14,
  b15,
  b16,
  b17,
  b18,
  b19,
  b20,
  b21,
  b22,
  b23,
  b24,
  b25,
  b26,
  b27,
  b28,
  b29,
  b30,
  b32,
  b34,
  b35,
  b36,
  b37,
];

const MAX_MOBILE_SCREEN_WIDTH = 768;
const CUSTOMER = 'customer';
const PROVIDER = 'provider';

const gblVenuWrapper = 'gblVenuWrapper';
const DESKTOP_MAX_CONTAINER_WIDTH = 1400;
const TAB_MAX_CONTAINER_WIDTH = 1024;
const MOBILE_MAX_CONTAINER_WIDTH = 576;
const CONTAINER_DESKTOP_OFFSET_WIDTH = 0;
const LISTING_CARD_WIDTH = 384;
const CONTAINER_TAB_OFFSET_WIDTH = 48;
const CONTAINER_MOBILE_OFFSET_WIDTH = 49;

// Panel width relative to the viewport
const panelMediumWidth = 50;
const panelLargeWidth = 62.5;
const cardRenderSizes = [
  '(max-width: 767px) 100vw',
  `(max-width: 1023px) ${panelMediumWidth}vw`,
  `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
  `${panelLargeWidth / 3}vw`,
].join(', ');

// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

const getMetadata = (meta, schemaType, fieldOptions) => {
  const { pageTitle, pageDescription, socialSharing } = meta;

  // pageTitle is used for <title> tag in addition to page schema for SEO
  const title = validProps(pageTitle, fieldOptions)?.content;
  // pageDescription is used for different <meta> tags in addition to page schema for SEO
  const description = validProps(pageDescription, fieldOptions)?.content;
  // Data used when the page is shared in social media services
  const openGraph = validProps(socialSharing, fieldOptions);
  // We add OpenGraph image as schema image if it exists.
  const schemaImage = openGraph?.images1200?.[0]?.url;
  const schemaImageMaybe = schemaImage ? { image: [schemaImage] } : {};
  const isArticle = ['Article', 'NewsArticle', 'TechArticle'].includes(schemaType);
  const schemaHeadlineMaybe = isArticle ? { headline: title } : {};

  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org (This template uses JSON-LD format)
  //
  // In addition to this schema data for search engines, src/components/Page/Page.js adds some extra schemas
  // Read more about schema:
  // - https://schema.org/
  // - https://developers.google.com/search/docs/advanced/structured-data/intro-structured-data
  const pageSchemaForSEO = {
    '@context': 'http://schema.org',
    '@type': schemaType || 'WebPage',
    description: description,
    name: title,
    ...schemaHeadlineMaybe,
    ...schemaImageMaybe,
  };

  return {
    title,
    description,
    schema: pageSchemaForSEO,
    socialSharing: openGraph,
  };
};

const reviews = [
  {
    id: 1,
    photo: rider,
    quote:
      '“I had a fantastic experience using The Animal List to hire animal talent for my ad. It was easy to find the perfect animals, book them for the production, and communicate seamlessly with the provider. I highly recommend it to fellow producers!”',
    author: 'Mildred Coleman, Advertisement Producer',
  },
  {
    id: 2,
    photo: rider,
    quote:
      '“I had a fantastic experience using The Animal List to hire animal talent for my ad. It was easy to find the perfect animals, book them for the production, and communicate seamlessly with the provider. I highly recommend it to fellow producers!”',
    author: 'Mildred Coleman, Advertisement Producer',
  },
  {
    id: 3,
    photo: rider,
    quote:
      '“I had a fantastic experience using The Animal List to hire animal talent for my ad. It was easy to find the perfect animals, book them for the production, and communicate seamlessly with the provider. I highly recommend it to fellow producers!”',
    author: 'Mildred Coleman, Advertisement Producer',
  },
  {
    id: 4,
    photo: rider,
    quote:
      '“I had a fantastic experience using The Animal List to hire animal talent for my ad. It was easy to find the perfect animals, book them for the production, and communicate seamlessly with the provider. I highly recommend it to fellow producers!”',
    author: 'Mildred Coleman, Advertisement Producer',
  },
  {
    id: 5,
    photo: rider,
    quote:
      '“I had a fantastic experience using The Animal List to hire animal talent for my ad. It was easy to find the perfect animals, book them for the production, and communicate seamlessly with the provider. I highly recommend it to fellow producers!”',
    author: 'Mildred Coleman, Advertisement Producer',
  },
  {
    id: 6,
    photo: rider,
    quote:
      '“I had a fantastic experience using The Animal List to hire animal talent for my ad. It was easy to find the perfect animals, book them for the production, and communicate seamlessly with the provider. I highly recommend it to fellow producers!”',
    author: 'Mildred Coleman, Advertisement Producer',
  },
];

export const SellerLandingPageComponent = props => {
  const {
    pageAssetsData,
    inProgress,
    error,
    schemaType,
    viewport,
    history,
    currentUser,
    isAuthenticated,
    ...pageProps
  } = props;
  const { sections = [], meta = {} } = pageAssetsData || {};
  const pageMetaProps = getMetadata(meta, schemaType);
  const containerRef = useRef(null);
  const [keyword, setKeyword] = useState('');

  const route = useRouteConfiguration();

  const { userType, providerCategory } = currentUser?.attributes?.profile?.publicData || {};
  const currentUserLoaded = !!currentUser?.id;

  const isCustomer = userType === CUSTOMER;
  const isProvider = userType === PROVIDER;
  if (isAuthenticated && currentUserLoaded && !userType) {
    return <NamedRedirect name="OnboardRootPage" />;
  } else if (isAuthenticated && currentUserLoaded && isProvider && !providerCategory) {
    return <NamedRedirect name="OnboardRootPage" />;
  }
  useEffect(() => {
    if (containerRef.current !== null) {
      const firstChild = containerRef.current.firstElementChild;
      const { width } = viewport;
      if (width >= MOBILE_MAX_CONTAINER_WIDTH && width < TAB_MAX_CONTAINER_WIDTH) {
        // console.log(1);
        firstChild.style.maxWidth = `${width - CONTAINER_TAB_OFFSET_WIDTH}px`;
      } else if (width >= TAB_MAX_CONTAINER_WIDTH && width < DESKTOP_MAX_CONTAINER_WIDTH) {
        // console.log(2, width, CONTAINER_DESKTOP_OFFSET_WIDTH);

        // firstChild.style.maxWidth = `${width - CONTAINER_DESKTOP_OFFSET_WIDTH}px`;
        firstChild.style.maxWidth = `${width - 220}px`;
      } else if (width >= DESKTOP_MAX_CONTAINER_WIDTH) {
        // console.log(3);

        firstChild.style.maxWidth = `${DESKTOP_MAX_CONTAINER_WIDTH -
          CONTAINER_DESKTOP_OFFSET_WIDTH}px`;
      } else {
        // console.log(4);

        firstChild.style.maxWidth = `${width - CONTAINER_MOBILE_OFFSET_WIDTH}px`;
      }
      const totalWidth =
        firstChild.children.length > 1
          ? firstChild.children[1].offsetWidth
          : firstChild.children[0].offsetWidth;

      // const newItemCount = parseFloat((totalWidth / LISTING_CARD_WIDTH).toFixed(1));
      // if (prevState.itemCount !== newItemCount) this.setState({ itemCount: newItemCount });
    }
  }, [viewport]);

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <PrevButton type="prev" />,
    nextArrow: <NextButton type="next" />,
  };
  var brandSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: viewport.width < 575 ? 3 : viewport.width < 1023 ? 5 : 7,
    slidesToScroll: viewport.width < 1023 ? 3 : 5,
    arrows: true,
    prevArrow: <PrevButton type="prev" />,
    nextArrow: <NextButton type="next" />,
  };
  const routes = useRouteConfiguration();
  const createListingFunction = () => {
    return history.push(createResourceLocatorString('PostListingGuide', routes));
  };
  const mainContent = (
    <div className={css.mainContainer}>
      <div className={css.heroSection}>
        <div className={css.leftSection}>
          <div className={css.title}>
            <p>Unlock Your Pet's Star Potential</p>
          </div>
          <div className={css.subTitle}>
            Connecting animals and animal lovers with exciting opportunities
          </div>
          <div className={css.searchContainer}>
            <button type="button" onClick={createListingFunction}>
              Create an Animal Listing
            </button>
            <button
              type="button"
              onClick={e => {
                history.push(
                  createResourceLocatorString(
                    'SearchPage',
                    routes,
                    {},
                    { pub_listingCategory: 'castingCall' }
                  )
                );
              }}
            >
              View Casting Calls
            </button>
          </div>
          {/* <div className={css.postListingLink}>
            Want to create your own listing?{' '}
            <span
              onClick={() => {
                if (isCustomer) {
                  history.push(createResourceLocatorString('PostCastingCall', route, {}, {}));
                } else if (isProvider) {
                  history.push(createResourceLocatorString('PostListing', route, {}, {}));
                } else {
                }
              }}
            >
              Click here.
            </span>
          </div> */}
        </div>
        <video autoPlay muted playsInline loop>
          <source src={HeroVideo} type="video/mp4" />
        </video>
        {/* <VideoPlayer videoUrl={HeroVideo} /> */}
      </div>
      <div className={`${css.sections} ${css.popularSearchContainer}`}>
        <div className={css.sectionBrandTitle}>Trusted By 1,500+ Animal Talent Buyers</div>
        <div className={css.popularMainSection}>
          <Slider {...brandSettings} className={css.slider}>
            {brandImgs.map((logo, idx) => (
              <div key={idx} className={css.quoteSection}>
                <img className={css.quoteImg} alt="" src={logo} />
              </div>
            ))}
          </Slider>
        </div>
      </div>
      <div className={`${css.sections} ${css.makingContainer}`}>
        <div>
          <h1>Making A Difference,</h1>
          <h1>Making Money</h1>
          <div className={css.benfdv}>
            <p>Earn Extra Income</p>
            <p>
              Open doors to paid opportunities, allowing your pet to be a part of exciting projects.
            </p>
          </div>
          <div className={css.benfdv}>
            <p>Wide-Ranging Opportunities</p>
            <p>
              Make the most of your pet's special skills by offering various services catering to a
              broad spectrum of opportunities in The Animal List.
            </p>
          </div>
          <div className={css.benfdv}>
            <p>Streamline Your Business</p>
            <p>
              From bookings to payment, we help ensure efficiency by securing credit card details at
              reservation for instant payments upon satisfactory job completion.
            </p>
          </div>
          <Button onClick={createListingFunction}>Create an Animal Listing</Button>
        </div>
        <img src={Benefitsofselling} alt="" />
      </div>
      <div className={`${css.sections} ${css.descriptionContainer}`}>
        <div className={css.descLeft}>
          <h2>Your Path to Becoming a Top Seller</h2>
          <div className={css.listSection}>
            {howALWorks.map((h, idx) => (
              <div key={idx} className={css.pointContainer}>
                {h.icon}
                <div className={css.lbl}>{`${idx + 1}. ${h.heading}`}</div>
                <p>{h.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={`${css.sections} ${css.exploreContainer}`}>
        <div className={css.exploreIconContainer}>
          <p className={css.sectionBrandTitle}>Ways To Make Money With The Animal List</p>
          <div className={css.firstRow}>
            {wayToMoney.map((w, i) => {
              return (
                <div key={i} className={css.iconGrp}>
                  <img src={w.icon} />
                  <div className={css.iconLabel}>{w.label}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className={`${css.sections} ${css.guideContainer}`}>
        <div className={css.guideLeft}>
          <div className={css.guideHeadingSection}>
            <p>PETS STARTS ACADEMY</p>
            <p>POWERED BY PETS ON Q</p>
          </div>
          <p className={css.elevp}>Elevate Your Skills With Expert-Led Courses</p>
          <p className={css.elevpdesc}>
            Boost your expertise with our specialized courses. Tailored for aspiring pet
            influencers, animal actors, and animal wranglers, these courses will guide you from
            novice to mastery, elevate your skills and excel in your animal talent career with our
            focused training.
          </p>
          <a target="_blank" href="https://www.petstars.com">
            Learn More
          </a>
        </div>
        <img alt="PetStarAcademyGraphic" src={PetStarAcademyGraphic} />
      </div>
    </div>
  );

  const layoutAreas = `
    topbar
    main
    footer
  `;
  return (
    // <StaticPage {...pageMetaProps} {...pageProps}>
    //   <LayoutComposer areas={layoutAreas} className={css.layout}>
    //     {props => {
    //       const { Topbar, Main, Footer } = props;
    //       return (
    //         <>
    //           <Topbar as="header" className={css.topbar}>
    //             <TopbarContainer />
    //           </Topbar>
    //           <Main as="main" className={css.main}>
    //             {mainContent}
    //           </Main>
    //           <FooterContainer />
    //         </>
    //       );
    //     }}
    //   </LayoutComposer>
    // </StaticPage>
    <Page>
      <TopbarContainer />
      {/* <LayoutSingleColumn>{mainContent}</LayoutSingleColumn> */}
      {mainContent}
      <FooterContainer />
    </Page>
  );
};

SellerLandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { isAuthenticated } = state.auth;
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const { currentUser } = state.user;
  return { pageAssetsData, inProgress, error, currentUser, isAuthenticated };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const SellerLandingPage = compose(
  withRouter,
  connect(mapStateToProps),
  withViewport
)(SellerLandingPageComponent);

export default SellerLandingPage;
